import {selectDomain} from '.';
import {createSelector} from 'reselect';
import {ObjectId} from 'types/object-id';

export default (id: ObjectId) =>
  createSelector([selectDomain], domain => {
    return !domain.stagedRecords[id];
  });
